import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * A spinner alone on the page — what a route shows while it is still working out
 * WHAT to show (waiting for the roles to replicate before it can pick an app, or
 * let one through). Deliberately bare: there is nothing to say yet, and a
 * sentence that flashes for 200ms is noise.
 */
export default function FullPageProgress() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <CircularProgress />
        </Box>
    );
}
